import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getCouponsBySearch(pageNum,pageSize) {
  return request({
    url: '/coupons/getCouponsBySearch',
    params: {
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function delByCouponsId(id) {
  return requestMsg({
    url: '/coupons/delByCouponsId',
    params: {
      id:id
    }
  })
}

export function getCouponsById(id) {
  return request({
    url: '/coupons/getCouponsById',
    params: {
      id:id
    }
  })
}

export function updateCoupons(coupons) {
  return requestMsg({
    url: '/coupons/updateCoupons',
    data: JSON.stringify(coupons),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}
